import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppBase } from '@app/shared/models/app-base';

@Injectable()
export class HttpBaseUrlInterceptor implements HttpInterceptor {
  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.startsWith('http')) { return next.handle(req); }

    const url = `${AppBase.href}${req.url}`;
    req = req.clone({ url });

    return next.handle(req);
  }
}
